"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DotdigitalProgrammeClient = void 0;
const model_client_1 = require("../../model-client");
class DotdigitalProgrammeClient extends model_client_1.ModelClient {
    getModelName() {
        return 'dotdigital-programme';
    }
    getVersion() {
        return 'v1';
    }
    isPublic() {
        return false;
    }
}
exports.DotdigitalProgrammeClient = DotdigitalProgrammeClient;
//# sourceMappingURL=dotdigital-programme-client.js.map